import { css } from 'lit-element';
const style = css`
:host([align="column"]) fc-select {
  --fc-select-width: 100%;
}`;
export default style;
